import {StyledIconContainer} from '@components/ui/icon-container/style.ts'
import {FC, ReactNode} from 'react'

interface IconContainerProps {
    children: ReactNode
    size?: 'md' | 'lg'
    type?: 'neutral' | 'danger' | 'success' | 'warning'
    radiusFull?: boolean
}
export const IconContainer: FC<IconContainerProps> = ({
    children,
    size = 'md',
    type = 'neutral',
    radiusFull = false
}) => {
    return (
        <StyledIconContainer $radiusFull={radiusFull} $size={size} $type={type}>
            {children}
        </StyledIconContainer>
    )
}

IconContainer.displayName = 'IconContainer'
